import M from "./index257.js";
import { resolveComponent as d, createElementBlock as s, createCommentVNode as l, openBlock as t, normalizeClass as b, createElementVNode as r, createBlock as a, createVNode as y, createTextVNode as C, Fragment as S, renderList as T, Transition as V, withCtx as D, KeepAlive as I, withDirectives as h, vShow as f, toDisplayString as i } from "vue";
/* empty css         */
import $ from "./index231.js";
const A = ["data-component"], E = { class: "cs-gallery__head" }, G = { class: "cs-gallery__content" }, N = {
  key: 0,
  class: "cs-gallery__imageWrapper"
}, z = {
  key: 1,
  class: "cs-gallery__imageWrapper"
}, B = ["src", "alt"], U = {
  key: 2,
  class: "cs-gallery__footer"
}, W = { class: "cs-gallery__description" }, F = {
  key: 0,
  class: "mt-8 text-caption text-color-neutral-grey-40"
}, K = {
  key: 0,
  class: "text-center",
  "data-test-id": "status"
};
function L(e, n, _, j, q, H) {
  var m;
  const k = d("ms-close"), c = d("cs-swiper"), w = d("ms-ad-place");
  return e.isVisible && e.content.length > 0 ? (t(), s("div", {
    key: 0,
    "data-component": e.$options.name,
    class: b(["cs-gallery", {
      "-grabbing": e.isGrabbing
    }]),
    onTouchstart: n[1] || (n[1] = (...o) => e.onTouchStart && e.onTouchStart(...o)),
    onTouchmove: n[2] || (n[2] = (...o) => e.onTouchMove && e.onTouchMove(...o)),
    onTouchend: n[3] || (n[3] = (...o) => e.onTouchEnd && e.onTouchEnd(...o)),
    onMousedown: n[4] || (n[4] = (...o) => e.onMouseDown && e.onMouseDown(...o)),
    onMousemove: n[5] || (n[5] = (...o) => e.onMouseMove && e.onMouseMove(...o)),
    onMouseup: n[6] || (n[6] = (...o) => e.onMouseUp && e.onMouseUp(...o))
  }, [
    r("div", E, [
      r("button", {
        class: "flex items-center gap-8 mb-16 font-bold text-text-l text-color-neutral-white hover:underline",
        type: "button",
        onClick: n[0] || (n[0] = (...o) => e.closeGallery && e.closeGallery(...o))
      }, [
        y(k, { class: "w-24 h-24" }),
        n[7] || (n[7] = C(" schließen "))
      ])
    ]),
    e.isScreenM && e.content.length > 1 ? (t(), a(c, {
      key: 0,
      class: "absolute rotate-90 -translate-y-1/2 left-24 screen-l:left-32 top-1/2 z-content-control",
      onClick: e.prev
    }, null, 8, ["onClick"])) : l("", !0),
    e.isScreenM && e.content.length > 1 ? (t(), a(c, {
      key: 1,
      class: "absolute -rotate-90 -translate-y-1/2 right-24 screen-l:right-32 top-1/2 z-content-control",
      onClick: e.next
    }, null, 8, ["onClick"])) : l("", !0),
    r("div", G, [
      (t(!0), s(S, null, T(e.content, (o, u) => (t(), a(V, {
        key: u,
        name: e.direction
      }, {
        default: D(() => {
          var p, g, v;
          return [
            (t(), a(I, null, [
              o.isAd ? h((t(), s("div", N, [
                y(w, {
                  placementId: (p = o.adContent) == null ? void 0 : p.id,
                  alwaysVisible: !0,
                  class: "max-w-full max-h-full overflow-y-scroll screen-m:overflow-y-auto"
                }, null, 8, ["placementId"])
              ], 512)), [
                [f, u === e.activeIndex]
              ]) : h((t(), s("div", z, [
                r("img", {
                  src: (g = o.image) == null ? void 0 : g.url,
                  alt: (v = o.image) == null ? void 0 : v.description,
                  draggable: "false",
                  class: "max-w-full max-h-full select-none"
                }, null, 8, B)
              ], 512)), [
                [f, u === e.activeIndex]
              ])
            ], 1024))
          ];
        }),
        _: 2
      }, 1032, ["name"]))), 128))
    ]),
    e.currentSlide ? (t(), s("div", U, [
      r("div", W, [
        r("div", null, i(e.determineDescription(e.currentSlide)), 1),
        e.showAuthor ? (t(), s("div", F, " © " + i((m = e.currentSlide.image) == null ? void 0 : m.author), 1)) : l("", !0)
      ]),
      e.currentSlide.isAd ? l("", !0) : (t(), s("div", K, i(e.currentSlide.index) + "/" + i(e.images.length), 1))
    ])) : l("", !0)
  ], 42, A)) : l("", !0);
}
const R = /* @__PURE__ */ $(M, [["render", L], ["__scopeId", "data-v-b35ce09f"]]);
export {
  R as default
};
